

"use client";

import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Image from "next/image";
import { useLanguage } from "./context/LanguageContext";

const translations = {
  fr: {
    hello: "Salut c’est nous…",
    title: "Les Cookies !",
    description:
      "On a attendu d'être sûrs que le contenu de ce site vous intéresse avant de vous déranger, mais on aimerait bien vous accompagner pendant votre visite…",
    question: "C’est OK pour vous ?",
    certified: "Consentements certifiés par",
    you: "vous",
    noThanks: "Non merci",
    choose: "Je choisis",
    accept: "OK pour moi",
    close: "Fermer",
    cookiesAlt: "Cookies",
  },

  en: {
    hello: "Hi, it's us…",
    title: "Cookies!",
    description:
      "We waited until we were sure that the content of this site interests you before bothering you, but we'd love to accompany you during your visit…",
    question: "Is that OK with you?",
    certified: "Consent certified by",
    you: "you",
    noThanks: "No thanks",
    choose: "I choose",
    accept: "OK for me",
    close: "Close",
    cookiesAlt: "Cookies",
  },

  ar: {
    hello: "مرحبًا، نحن هنا…",
    title: "ملفات تعريف الارتباط!",
    description:
      "انتظرنا حتى نتأكد من أن محتوى هذا الموقع يهمك قبل أن نزعجك، لكننا نود أن نرافقك أثناء زيارتك…",
    question: "هل هذا مناسب لك؟",
    certified: "الموافقة مقدمة من",
    you: "أنت",
    noThanks: "لا، شكرًا",
    choose: "أختار",
    accept: "موافق",
    close: "إغلاق",
    cookiesAlt: "ملفات تعريف الارتباط",
  },
};

export default function CookiePopup() {
  const { language } = useLanguage();

  const [show, setShow] = useState(false);

  // Normalise language
  const currentLanguage =
    language === "fr" || language === "ar" || language === "en"
      ? language
      : "en";

  const t = translations[currentLanguage];

  useEffect(() => {
    const seen = Cookies.get("seen_popup");

    if (!seen) {
      setShow(true);
    }
  }, []);

  const closePopup = () => {
    setShow(false);

    Cookies.set("seen_popup", "true", {
      expires: 365,
      sameSite: "lax",
    });
  };

  if (!show) return null;

  const isArabic = currentLanguage === "ar";

  return (
    <div
      dir={isArabic ? "rtl" : "ltr"}
      className={`fixed bottom-5 z-[9999] animate-slideUp ${
        isArabic ? "right-5" : "left-5"
      }`}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-[420px] max-w-[calc(100vw-40px)] overflow-hidden border border-gray-200">
        
        {/* Header + image */}
        <div
          className={`flex items-center gap-4 bg-blue-100 p-5 ${
            isArabic ? "flex-row-reverse" : ""
          }`}
        >
          <Image
            src="/test.png"
            alt={t.cookiesAlt}
            width={70}
            height={70}
            className="rounded-full"
          />

          <div>
            <h2 className="text-lg font-bold text-blue-900 leading-tight">
              {t.hello}
            </h2>

            <h1 className="text-2xl font-extrabold text-purple-700 leading-tight">
              {t.title}
            </h1>
          </div>
        </div>

        {/* Description */}
        <div className="p-5 text-[15px] text-gray-700 leading-relaxed">
          {t.description}

          <br />

          <strong>{t.question}</strong>
        </div>

        {/* Footer */}
        <p className="text-xs text-center text-gray-500 mb-2">
          {t.certified}{" "}
          <span className="font-semibold">{t.you}</span>
        </p>

        {/* Buttons */}
        <div className="grid grid-cols-3 text-sm border-t">
          <button
            onClick={closePopup}
            className="py-3 hover:bg-gray-100 transition"
          >
            {t.noThanks}
          </button>

          <button
            onClick={closePopup}
            className="py-3 hover:bg-gray-100 border-l border-r transition"
          >
            {t.choose}
          </button>

          <button
            onClick={closePopup}
            className="py-3 bg-yellow-500 text-white font-bold hover:bg-yellow-600 transition"
          >
            {t.accept}
          </button>
        </div>
      </div>

      {/* Close button */}
      <button
        onClick={closePopup}
        aria-label={t.close}
        title={t.close}
        className={`absolute -top-3 ${
          isArabic ? "-left-3" : "-right-3"
        } bg-purple-600 text-white w-7 h-7 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-700 transition`}
      >
        ✕
      </button>

      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-slideUp {
          animation: slideUp 0.45s ease-out forwards;
        }
      `}</style>
    </div>
  );
}

/*
"use client";

import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Image from "next/image";

export default function CookiePopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const seen = Cookies.get("seen_popup");
    if (!seen) {
      setShow(true);
      Cookies.set("seen_popup", "true", { expires: 365 });
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-5 left-5 z-[9999] animate-slideUp">
      <div className="bg-white rounded-2xl shadow-2xl w-[420px] overflow-hidden border border-gray-200">
        
       
        <div className="flex items-center gap-4 bg-blue-100 p-5">
          <Image
            src="/test.png"
            alt="Cookies"
            width={70}
            height={70}
            className="rounded-full"
          />
          <div>
            <h2 className="text-lg font-bold text-blue-900 leading-tight">
              Salut c’est nous…
            </h2>
            <h1 className="text-2xl font-extrabold text-purple-700 leading-tight">
              Les Cookies !
            </h1>
          </div>
        </div>

      
        <div className="p-5 text-[15px] text-gray-700 leading-relaxed">
          On a attendu d'être sûrs que le contenu de ce site vous intéresse 
          avant de vous déranger, mais on aimerait bien vous accompagner 
          pendant votre visite…  
          <br />
          <strong>C’est OK pour vous ?</strong>
        </div>

        
        <p className="text-xs text-center text-gray-500 mb-2">
          Consentements certifiés par <span className="font-semibold">vous</span>
        </p>

       
        <div className="grid grid-cols-3 text-sm border-t">

          <button
            onClick={() => setShow(false)}
            className="py-3 hover:bg-gray-100"
          >
            Non merci
          </button>

          <button
            onClick={() => setShow(false)}
            className="py-3 hover:bg-gray-100 border-l border-r"
          >
            Je choisis
          </button>

          <button
            onClick={() => setShow(false)}
            className="py-3 bg-yellow-500 text-white font-bold hover:bg-yellow-600"
          >
            OK pour moi
          </button>
        </div>
      </div>

    
      <button
        onClick={() => setShow(false)}
        className="absolute -top-3 -right-3 bg-purple-600 text-white w-7 h-7 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-700"
      >
        ✕
      </button>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-slideUp {
          animation: slideUp 0.45s ease-out forwards;
        }
      `}</style>
    </div>
  );
}
  */